import type { GetALMIssuesResponse } from "@/backend/natsstubs/almsync/common/models";

import { retrieveBackendSession } from "../impl/backendSessionCache";

interface IssueFilters {
  text?: string; // text search filter (by summary or ALM ID)
  almTypeIds?: string[];
  assigneeIds?: string[]; // pip user IDs (special ID "no" = unassigned, backend translates to ALM IDs)
  linkedTo?: string[]; // ALM IDs of work items to filter by linked issues
}

/**
 * Fetch ALM issues for the team issue selector.
 * Returns backlog issues (NOT in current sprint), limited to 100 items.
 *
 * @param teamId - Team ID to fetch issues for
 * @param sessionId - PI session ID
 * @param filters - Optional filters for type and assignee (assigneeIds are pip user IDs, "no" = unassigned)
 */
export async function fetchAlmIssues(
  teamId: string,
  sessionId: string,
  filters: IssueFilters,
): Promise<GetALMIssuesResponse> {
  const session = retrieveBackendSession();
  if (!session) {
    throw new Error("Backend session not initialized");
  }

  // Only send filters if at least one filter is specified
  const hasFilters =
    filters.text ||
    filters.almTypeIds?.length ||
    filters.assigneeIds?.length ||
    filters.linkedTo?.length;

  return await session.getAlmIssues({
    teamId: parseInt(teamId),
    sessionId: sessionId,
    filters: hasFilters
      ? {
          text: filters.text,
          almTypeIds: filters.almTypeIds?.length ? filters.almTypeIds : undefined,
          assigneeIds: filters.assigneeIds?.length ? filters.assigneeIds : undefined,
          linkedTo: filters.linkedTo?.length ? filters.linkedTo : undefined,
        }
      : undefined,
  });
}
